module.exports = __webpack_public_path__ + "media/Aizat Amdan - Sampai Ke Hari Tua.86bf3219.mp3";